import { render, staticRenderFns } from "./ReviewAndSave.vue?vue&type=template&id=1e8b2c84&scoped=true"
import script from "./ReviewAndSave.vue?vue&type=script&lang=ts"
export * from "./ReviewAndSave.vue?vue&type=script&lang=ts"
import style0 from "./ReviewAndSave.vue?vue&type=style&index=0&id=1e8b2c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b2c84",
  null
  
)

export default component.exports